import animation, { fadeInUp } from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { from } from '@helpers/media';
import styled from 'styled-components';

const Details = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${brand.red.base};
  padding: 30px 20px;
  transition: background-color 175ms ${animation.easeInOutCubic};
`;

const Card = styled.a<{ cardInView: boolean; delay: number }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 15px;

  ${({ cardInView, delay }) => fadeInUp(cardInView, 25, 500, delay, animation.easeInOutCubic)};

  &:last-child {
    margin-bottom: 0px;

    @media ${from(600)} {
      margin-bottom: inherit;
    }
  }

  &:hover ${Details} {
    background-color: ${brand.red.dark};
  }
`;

const Small = styled.small`
  font-size: 16px;
  ${fonts.helvetica['53-extended']};
  text-transform: uppercase;
  color: ${brand.white};
  margin-bottom: 30px;
`;

const Title = styled.h3`
  font-size: 18px;
  line-height: 1.2;
  ${fonts.helvetica['83-heavy-extended']};
  text-transform: uppercase;
  color: ${brand.white};
  margin-bottom: 40px;
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  background-color: ${brand.grey[90]};
  padding: 6px 20px;

  svg {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  span {
    font-size: 10px;
    line-height: 1.2;
    ${fonts.helvetica['83-heavy-extended']};
    color: ${brand.black};
    text-transform: uppercase;
  }
`;

export const CareerCardStyles = { Card, Details, Small, Title, ButtonWrapper, Location };
